import { Directive } from '@angular/core';

@Directive({
    selector: '[appSafehtml]',
    standalone: false
})
export class SafehtmlDirective {

  constructor() { }

}
